import { useLogisticsById } from '@/queries/route-planner';
import { useBaseCaseDetails } from '@/hooks/useBaseCaseDetails';

export const useLogisticsData = () => {
  const { logisticsReference } = useBaseCaseDetails();
  const { data: logisticsData } = useLogisticsById(logisticsReference?.id);

  if (!logisticsData) {
    throw new Error('No logistics data provided');
  }

  return logisticsData;
};
